import React, { useState } from 'react';
import { CustomSecondaryCheckBox } from '../../../../shared/customSecondaryCheckBox';
import { CustomButton } from '../../../../shared/customButton';
import { CustomDraggbleTextField } from '../../../../shared/customDraggbleTextField';
import { Col, Container, Row } from 'react-bootstrap';
import { Formik, Form, FieldArray } from 'formik';
import styles from './additionalDetails.module.scss';
import * as Yup from 'yup';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { CustomAlertBox } from '../../../../shared/customAlertBox';
import { id } from 'date-fns/locale';

const AdditionalDetails = (props) => {

    const initialValues = {
        coverLetter: props.pipelineValues.coverLetter,
        salaryExpectation: props.pipelineValues.salaryExpectation,
        availableDate: props.pipelineValues.availableDate,
        customQuestions: props.pipelineValues.customQuestions,
    };
    const validationSchema = Yup.object().shape({
        customQuestions: Yup.array().of(
            Yup.object().shape({
                question: Yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required')
            })
        ),

    });
    const onSubmit = async (values) => {
        props.setAdditionalDetails(values);
        props.nextPage(4)
    }

    const addAdditionalQuestion = (e, values, setValues) => {

        const customQuestions = [...values.customQuestions];

        let newCustomQuestion = {
            question: ''
        }

        customQuestions.push(newCustomQuestion);
        setValues({ ...values, customQuestions });

    }

    const removeAddiionalQuestion = (e, id, values, setValues) => {
        const customQuestions = [...values.customQuestions];
        if (customQuestions.length !== 0) {
            let newArray = customQuestions.filter(function (obj, index) {
                return index !== id;
            });
            setValues({ ...values, customQuestions: newArray });
        }
    }

    const msgSvg = (
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="message-text-circle-02">
                <path id="Icon" d="M5.33333 6.83333H8M5.33333 9.16667H10M8 14.5C11.3137 14.5 14 11.8137 14 8.5C14 5.18629 11.3137 2.5 8 2.5C4.68629 2.5 2 5.18629 2 8.5C2 9.2981 2.15582 10.0598 2.43871 10.7563C2.49285 10.8897 2.51992 10.9563 2.532 11.0102C2.54381 11.0629 2.54813 11.1019 2.54814 11.1559C2.54814 11.2111 2.53812 11.2713 2.51807 11.3916L2.12275 13.7635C2.08135 14.0119 2.06065 14.1361 2.09917 14.2259C2.13289 14.3045 2.19552 14.3671 2.27412 14.4008C2.36393 14.4393 2.48812 14.4186 2.73651 14.3772L5.10843 13.9819C5.22872 13.9619 5.28887 13.9519 5.34409 13.9519C5.3981 13.9519 5.43711 13.9562 5.48981 13.968C5.54369 13.9801 5.61035 14.0072 5.74366 14.0613C6.4402 14.3442 7.2019 14.5 8 14.5Z" stroke="" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
            </g>
        </svg>
    )

    const salarySvg = (
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="bank-note-01">
                <path id="Icon" d="M3.99998 7.83334V10.5M12 6.5V9.16667M11.3333 3.16667C12.9658 3.16667 13.8487 3.41651 14.2881 3.6103C14.3466 3.63611 14.3758 3.64901 14.4602 3.72959C14.5109 3.77788 14.6032 3.9196 14.627 3.9854C14.6666 4.09516 14.6666 4.15516 14.6666 4.27517V11.4408C14.6666 12.0466 14.6666 12.3495 14.5758 12.5052C14.4834 12.6636 14.3943 12.7373 14.2213 12.7981C14.0512 12.858 13.708 12.792 13.0214 12.6601C12.5409 12.5678 11.971 12.5 11.3333 12.5C9.33331 12.5 7.33331 13.8333 4.66665 13.8333C3.03417 13.8333 2.15122 13.5835 1.7119 13.3897C1.6534 13.3639 1.62414 13.351 1.53971 13.2704C1.4891 13.2221 1.39672 13.0804 1.37296 13.0146C1.33331 12.9048 1.33331 12.8448 1.33331 12.7248L1.33331 5.55924C1.33331 4.9534 1.33331 4.65047 1.42416 4.49477C1.51658 4.33638 1.60571 4.26275 1.77869 4.20188C1.94874 4.14204 2.292 4.20799 2.97853 4.3399C3.45906 4.43223 4.02897 4.5 4.66665 4.5C6.66665 4.5 8.66665 3.16667 11.3333 3.16667ZM9.66665 8.5C9.66665 9.42048 8.92045 10.1667 7.99998 10.1667C7.07951 10.1667 6.33331 9.42048 6.33331 8.5C6.33331 7.57953 7.07951 6.83334 7.99998 6.83334C8.92045 6.83334 9.66665 7.57953 9.66665 8.5Z" stroke="" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
            </g>
        </svg>
    )

    const availableDateSvg = (
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="calendar-check-01">
                <path id="Icon" d="M14 7.16666H2M10.6667 1.83333V4.49999M5.33333 1.83333V4.49999M6 11.1667L7.33333 12.5L10.3333 9.5M5.2 15.1667H10.8C11.9201 15.1667 12.4802 15.1667 12.908 14.9487C13.2843 14.7569 13.5903 14.451 13.782 14.0746C14 13.6468 14 13.0868 14 11.9667V6.36666C14 5.24656 14 4.6865 13.782 4.25868C13.5903 3.88236 13.2843 3.5764 12.908 3.38465C12.4802 3.16666 11.9201 3.16666 10.8 3.16666H5.2C4.0799 3.16666 3.51984 3.16666 3.09202 3.38465C2.71569 3.5764 2.40973 3.88236 2.21799 4.25868C2 4.6865 2 5.24656 2 6.36666V11.9667C2 13.0868 2 13.6468 2.21799 14.0746C2.40973 14.451 2.71569 14.7569 3.09202 14.9487C3.51984 15.1667 4.0799 15.1667 5.2 15.1667Z" stroke="" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
            </g>
        </svg>

    )

    return (
        <div>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values) => onSubmit(values)}
            >
                {({
                    values,
                    errors,
                    handleSubmit,
                    handleChange,
                    touched,
                    setValues,
                    submitCount,
                    setFieldValue
                }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <div className={styles.responsibilitiesDiv}>
                            <p className={styles.subTopics}>Required Additional Details From Candidates</p>
                        </div>
                        <div className={styles.alertDiv}>
                                <CustomAlertBox alertType="defaultAlert" alertBodyText="Mark the radio buttons if you need those additional details from candidates apart from default details. Selected fields will be added to application form." />
                        </div>
                        <Row>
                            <Col cm={12}>
                                <CustomSecondaryCheckBox
                                    svg={msgSvg} // Pass the SVG code as a prop
                                    id="adminPanel_hiringPipelines_createPipelineModal_additionalDetails_coverLetterCheckBoxId"
                                    label="Cover Letter"
                                    controlId="adminPanel_hiringPipelines_createPipelineModal_additionalDetails_coverLetterDivId"
                                    name="coverLetter"
                                    handleOnChange={() => { setFieldValue(`coverLetter`, !values.coverLetter); }}
                                    type="defaultCheckBox"
                                    value={values.coverLetter}
                                    ischecked={values.coverLetter}

                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col cm={12}>
                                <CustomSecondaryCheckBox
                                    svg={salarySvg} // Pass the SVG code as a prop
                                    id="adminPanel_hiringPipelines_createPipelineModal_additionalDetails_salaryExpectationCheckBoxId"
                                    label="Salary Expectation"
                                    controlId="adminPanel_hiringPipelines_createPipelineModal_additionalDetails_salaryExpectationDivId"
                                    name="salaryExpectation"
                                    handleOnChange={() => { setFieldValue(`salaryExpectation`, !values.salaryExpectation); }}
                                    type="defaultCheckBox"
                                    value={values.salaryExpectation}
                                    ischecked={values.salaryExpectation}

                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col cm={12}>
                                <CustomSecondaryCheckBox
                                    svg={availableDateSvg} // Pass the SVG code as a prop
                                    id="adminPanel_hiringPipelines_createPipelineModal_additionalDetails_availableDateCheckBoxId"
                                    label="Available Date"
                                    controlId="adminPanel_hiringPipelines_createPipelineModal_additionalDetails_availableDateDivId"
                                    name="availableDate"
                                    handleOnChange={() => { setFieldValue(`availableDate`, !values.availableDate); }}
                                    type="defaultCheckBox"
                                    value={values.availableDate}
                                    ischecked={values.availableDate}

                                />
                            </Col>
                        </Row>
                       
                        <div className={styles.responsibilitiesDiv}>
                            <p className={styles.subTopics}>Custom Questions</p>
                        </div>
                        <div className={styles.alertDiv}>
                                <CustomAlertBox alertType="defaultAlert" alertBodyText="Ask custom questions from candidates to understand their profile better. These questions will be added to application form." />
                        </div>
                        <div>
                            <FieldArray name="customQuestions">
                                {(arrayHelpers) => {
                                    const handleOnDragEnd = (result) => {
                                        if (!result.destination) {
                                            return;
                                        }

                                        const { source, destination } = result;

                                        arrayHelpers.move(source.index, destination.index);
                                    };
                                    return (
                                        <DragDropContext onDragEnd={handleOnDragEnd}>
                                            <Droppable droppableId="customQuestions">
                                                {(provided) => (
                                                    <div ref={provided.innerRef} {...provided.droppableProps}>
                                                        <>
                                                            {!values.customQuestions  || values.customQuestions.length === 0 ? (
                                                                <p className={styles.emptyMessage}>-- No Added Custom Questions  --</p>
                                                            ) : (
                                                                values.customQuestions.map((question, i) => {
                                                                    const customQuestionErrors = (errors.customQuestions?.length && errors.customQuestions[i]) || {};
                                                                    const customQuestionTouched = (touched.customQuestions?.length && touched.customQuestions[i]) || {};
                                                                    return (
                                                                        <Draggable key={i} draggableId={`customQuestion-${i}`} index={i}>
                                                                            {(provided) => (
                                                                                <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                                                    <CustomDraggbleTextField
                                                                                        keyValue={i}
                                                                                        classLabel="defaultLabel"
                                                                                        placeholder="Enter a description..."
                                                                                        controlId={`adminPanel_hiringPipelines_createPipelineModal_additionalDetails_customQuestionsFieldId.${i}`}
                                                                                        type="text"
                                                                                        value={(values && values.customQuestions && values.customQuestions[i]) && values.customQuestions[i].question}
                                                                                        handleOnChange={handleChange}
                                                                                        name={`customQuestions.${i}.question`}
                                                                                        classType="defaultTextBox"
                                                                                        onCancelClick={(e) => removeAddiionalQuestion(e, i, values, setValues)}
                                                                                        errorMessage={(errors && errors.customQuestions && errors.customQuestions[i]) && errors.customQuestions[i].question}
                                                                                        validationMessageId={`adminPanel_hiringPipelines_createPipelineModal_additionalDetails_customQuestionsValidationMsgId.${i}`}
                                                                                        isInvalid={!!(customQuestionErrors.question && customQuestionTouched.question)}
                                                                                        isCancelable={true}
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                        </Draggable>
                                                                    );
                                                                })
                                                            )}
                                                            {provided.placeholder}
                                                        </>
                                                    </div>
                                                )}
                                            </Droppable>
                                        </DragDropContext>
                                    );
                                }}
                            </FieldArray>
                            <CustomButton
                                id="adminPanel_hiringPipelines_createPipelineModal_additionalDetails_addCustomQuestionsBtnId"
                                buttonType="button"
                                label="Add Custom Question"
                                type="secondarySmallBtn"
                                handleClick={(e) => addAdditionalQuestion(e, values, setValues)}
                                frontIcon={
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                        <path d="M10 4.66667V16.3333M4.16669 10.5H15.8334" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                }
                            />
                        </div>

                        <hr className={styles.dividerLine} />
                        <Row className="mt-3 d-flex flex-row-reverse">
                            <div className={styles.navigateBtnCol}>
                                <CustomButton
                                    id="adminPanel_hiringPipelines_createPipelineModal_additionalDetails_additionalDetailsNextBtnId"
                                    buttonType="submit"
                                    label="Review"
                                    type="primaryBtn"
                                />
                            </div>
                            <div className={styles.navigateBtnCol}>
                                <CustomButton
                                    id="pipeline_additional_detail_cancel"
                                    buttonType="button"
                                    label="Back"
                                    type="defaultBtn"
                                    handleClick={() => props.previousPage(2)}
                                />
                            </div>

                        </Row>


                    </Form>
                )}
            </Formik>
        </div >
    )
}

export default AdditionalDetails